import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=a6b2a0f2&scoped=true"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=a6b2a0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2a0f2",
  null
  
)

export default component.exports